export default __webpack_public_path__ + "static/media/baozi.9e18f31d.gif";